import { render, staticRenderFns } from "./AssessmentViewModal.vue?vue&type=template&id=3bcd29f3&scoped=true"
import script from "./AssessmentViewModal.vue?vue&type=script&lang=ts"
export * from "./AssessmentViewModal.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentViewModal.vue?vue&type=style&index=0&id=3bcd29f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd29f3",
  null
  
)

export default component.exports